import React, { useState } from "react";
import { ICandidateDetails } from "../../../../store/superadmin/types";
import { getFormatedDate } from "../../../../utils/dataParser";
import Play from "../../../UI/Icons/Play";
import OnlineInterviewVideoPlay from "../PopupModal/OnlineInterviewVideoPlay";

interface ClientOnlineInterviewProps {
  showOnlineInterview: boolean;
  reviewCandidateData: ICandidateDetails | null;
}

const ClientOnlineInterview: React.FC<ClientOnlineInterviewProps> = ({
  showOnlineInterview,
  reviewCandidateData,
}) => {

  const [showVideoModal, setShowVideoModal] = useState(false);
  const [answer, setAnswer] = useState(null);

  const viddiResponse = reviewCandidateData?.profile?.viddi_candidate && JSON.parse(reviewCandidateData?.profile?.viddi_candidate?.viddi_response)

  const handleOpenVideoPopupModal = (answer: any) => {
    setShowVideoModal(true)
    setAnswer(answer)
  }

  const onClickClose = () => {
    setShowVideoModal(false)
    setAnswer(null)
  }

  return (
    <>
      <OnlineInterviewVideoPlay 
        showVideoModal={showVideoModal}
        onClickClose={onClickClose}
        answer={answer}
      />

      <div
        className={`d-flex flex-column gap-20 ${
          !showOnlineInterview ? "d-none" : ""
        }`}
      >
        <div className="fs-22 fw-400 text-black">Online Interview</div>
        <div className="d-flex gap-10 flex-wrap">
            { reviewCandidateData?.profile.bypass_online_interview ? "Bypassed by Super Admin" : "" }
            {
              !reviewCandidateData?.profile.bypass_online_interview && reviewCandidateData?.profile?.viddi_candidate?.viddi_candidate_interview_status === 0 && "No Data"
            }
            { reviewCandidateData?.profile?.viddi_candidate?.viddi_candidate_interview_status === 1 && viddiResponse?.interview_instance?.answers?.map((answer: any, index: number) => 
              <>
                <div key={index} className="bg-white border border-grey-light radius-8px">
                    <div className="d-flex flex-column gap-3 p-15px">
                      <div className="fs-16 fw-700 text-black">{answer.interview_question.question_text}</div>
                      <div className="fs-13 fw-400 text-black">
                          Uploaded: {getFormatedDate(answer.created_datetime)}
                      </div>
                    </div>
                    <div className="w-210px h-160px position-relative">
                      <video width="210" height="160" className="object-fit-cover">
                        <source src={answer.answer_video_url} type="video/mp4"></source>
                      </video>
                      <div className="position-absolute top-50 start-50 translate-middle cursor-pointer" onClick={() => handleOpenVideoPopupModal(answer)}>
                        <Play />
                      </div>
                    </div>
                  </div>
              </>
            )}
        </div>
      </div>
    </>
  );
};

export default ClientOnlineInterview;
